import { AxiosResponse } from "axios";
import { useApiService } from "../../hooks/useApiService";
import { useHandleErrorService } from "../../hooks/useHandleErrorService";
import { API_ENDPOINT } from "../../constants/api-endpoints";
import { dateUtil } from "../../utility/dateUtil";
import { ITrip } from "../../interfaces/common-interfaces";
import { useContext } from "react";
import SettingsContext from "../../contexts/SettingsProvider";

export const useDockDisplayService = () => {

    const { fetchPublicRequest } = useApiService();
    const { handleError } = useHandleErrorService();
    const { settings } = useContext(SettingsContext)

    const fetchTrips = async (
        updateState: React.Dispatch<React.SetStateAction<any>>,
        setNextVesselTime: React.Dispatch<React.SetStateAction<string>>,
        ghat: string
    ) => {
        try {
            const response: AxiosResponse = await fetchPublicRequest(
                API_ENDPOINT.TRIPS_BY_ORIGIN,
                {
                    ghatId: ghat,
                    tripDate: dateUtil.formatDate(new Date().toISOString())
                }
            );

            const tripList = (response.data.object as ITrip[]) || [];
            const now = new Date();

            const today = dateUtil.formatDate(new Date().toISOString()); // e.g., "2025-06-21"

            const futureTrips = tripList
                .filter(trip => trip.dockNo === settings.dockNo)
                .map(trip => {
                    const dateTimeString = `${today}T${trip.departureTime}`; // "2025-06-21T15:30:00"
                    return {
                        ...trip,
                        fullDepartureTime: new Date(dateTimeString)
                    };
                })
                .filter(trip => trip.fullDepartureTime > now)
                .sort((a, b) => a.fullDepartureTime.getTime() - b.fullDepartureTime.getTime());

            const currentOutgoingTrip = futureTrips[0] || null;
            const nextTrip = futureTrips[1] || null;

            updateState(currentOutgoingTrip);
            setNextVesselTime(nextTrip?.departureTime || '');

        } catch (error) {
            handleError(error);
        }
    }

    return {
        fetchTrips
    }
}